module.exports = __webpack_public_path__ + "img/nago.f803c62d.png";